// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-layout {
  min-height: 100vh;
  background: var(--color-bg);
}

.download-content {
  padding: 24px 0;
  min-height: calc(100vh - 200px);
}

.content-container.download-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
}

/* 下载信息区域 */
.download-info-section {
  margin-bottom: 40px;
}

.download-info-card {
  background: var(--color-bg-white);
  border-radius: 16px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

/* 返回按钮 */
.back-button {
  padding: 24px 32px 16px 32px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  gap: 12px;
  align-items: center;
}

.home-button {
  color: var(--color-primary);
  font-weight: 500;
  transition: all 0.3s ease;
}

.home-button:hover {
  color: var(--color-primary-hover);
  background-color: var(--color-primary-light);
}

/* 应用信息行 */
.app-info-row {
  display: grid;
  grid-template-columns: 1fr 3fr;
  gap: 24px;
  padding: 16px 32px 24px 32px;
  border-bottom: 1px solid #f0f0f0;
}

.app-logo-section {
  display: flex;
  align-items: center;
  justify-content: center;
}

.app-logo-img {
  width: 160px;
  height: 160px;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.app-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.app-name {
  margin: 0 !important;
  font-size: 28px;
  font-weight: 700;
  color: var(--color-text);
  line-height: 1.2;
}

.app-developer {
  font-size: 14px;
  color: var(--color-text-secondary);
}

.app-rating {
  font-size: 16px;
  color: var(--color-primary);
}

/* 下载区域 */
.download-section {
  padding: 24px 32px;
  border-bottom: 1px solid #f0f0f0;
}

.download-title {
  margin: 0 0 24px 0 !important;
  color: var(--color-text);
  font-weight: 700;
  font-size: 18px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 12px;
  border-bottom: 2px solid var(--color-primary);
}

.download-buttons {
  margin-bottom: 16px;
}

.download-btn {
  height: 56px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 12px;
  border: none;
  transition: all 0.3s ease;
}

.download-btn.android {
  background: linear-gradient(135deg, #00b894 0%, #00a085 100%);
  color: white;
}

.download-btn.android:hover {
  background: linear-gradient(135deg, #00a085 0%, #008f76 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 184, 148, 0.3);
}

.download-btn.ios {
  background: linear-gradient(135deg, #6c5ce7 0%, #5f4dd0 100%);
  color: white;
}

.download-btn.ios:hover {
  background: linear-gradient(135deg, #5f4dd0 0%, #5240b9 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(108, 92, 231, 0.3);
}

.download-btn.disabled {
  background: #f0f0f0 !important;
  color: #999 !important;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

.download-hint {
  display: block;
  margin-top: 8px;
  font-size: 12px;
}

/* 应用描述区域 */
.app-description {
  padding: 24px 32px;
  border-bottom: 1px solid #f0f0f0;
}

.app-description .ant-typography {
  margin: 0 0 16px 0 !important;
  color: var(--color-text);
  font-weight: 700;
  font-size: 18px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 12px;
  border-bottom: 2px solid var(--color-primary);
}

.description-content {
  line-height: 1.6;
  color: var(--color-text-secondary);
  white-space: pre-wrap;
}

/* 安全提示区域 */
.security-notice {
  padding: 24px 32px;
  background: var(--color-bg);
  border-radius: 0;
  border-left: none;
}

.security-text {
  font-size: 13px;
  line-height: 1.5;
  color: var(--color-text-secondary);
}

/* 更多游戏区域 */
.more-games-section {
  background: var(--color-bg-white);
  border-radius: var(--border-radius-lg);
  padding: 32px;
  box-shadow: var(--shadow-sm);
  margin-bottom: 32px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.section-title {
  margin: 0 !important;
  color: var(--color-text);
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 700;
}

.section-icon {
  color: var(--color-primary);
  font-size: 16px;
  margin-right: 8px;
}

.games-grid {
  margin-bottom: 24px;
}

.game-card {
  background: var(--color-bg-white);
  border-radius: var(--border-radius);
  border: 1px solid #f0f0f0;
  overflow: hidden;
  cursor: pointer;
  transition: var(--transition);
  height: 100%;
}

.game-card-hover:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
  border-color: rgba(108, 92, 231, 0.2);
}

.game-card-image {
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1;
}

.game-card-img {
  width: 100%;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: var(--shadow-sm);
}

.game-card-info {
  padding: 0 12px 12px 12px;
}

.game-card-title {
  margin: 0 0 8px 0 !important;
  font-size: 13px;
  font-weight: 500;
  color: var(--color-text);
  line-height: 1.3;
}

.game-card-rating {
  display: flex;
  align-items: center;
  gap: 4px;
}

.game-card-rating .ant-rate {
  font-size: 10px !important;
  color: #faad14 !important;
}

.rating-text {
  font-size: 11px;
  color: var(--color-text-secondary);
  font-weight: 500;
}

.random-play-section {
  text-align: center;
  padding-top: 24px;
}

.btn-random-play {
  background: var(--color-primary) !important;
  border: none !important;
  border-radius: 9999px !important;
  height: 48px !important;
  padding: 0 32px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: white !important;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 8px;
}

.btn-random-play:hover {
  background: rgba(108, 92, 231, 0.9) !important;
  color: white !important;
  transform: translateY(-1px);
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .download-content {
    padding: 16px 0;
  }
  
  .content-container.download-container {
    padding: 0 16px;
  }
  
  .app-info-row {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 16px 20px 20px 20px;
  }
  
  .app-logo-img {
    width: 120px;
    height: 120px;
  }
  
  .app-name {
    font-size: 24px !important;
  }
  
  .download-section {
    padding: 20px;
  }
  
  .download-title {
    font-size: 16px !important;
  }
  
  .download-btn {
    height: 48px;
    font-size: 14px;
  }
  
  .app-description {
    padding: 20px;
  }
  
  .security-notice {
    padding: 20px;
  }

  .more-games-section {
    padding: 20px;
  }

  .section-title {
    font-size: 16px;
  }

  .game-card-title {
    font-size: 12px;
  }

  .btn-random-play {
    height: 44px !important;
    font-size: 14px !important;
    padding: 0 24px !important;
  }
}

@media (max-width: 480px) {
  .content-container.download-container {
    padding: 0 12px;
  }
  
  .back-button {
    padding: 20px 20px 12px 20px;
  }
  
  .app-info-row {
    padding: 12px 16px 16px 16px;
  }
  
  .app-logo-img {
    width: 100px;
    height: 100px;
  }
  
  .app-name {
    font-size: 20px !important;
  }
  
  .download-section {
    padding: 16px;
  }
  
  .download-title {
    font-size: 14px !important;
  }
  
  .download-btn {
    height: 44px;
    font-size: 13px;
  }
  
  .app-description {
    padding: 16px;
  }
  
  .security-notice {
    padding: 16px;
  }

  .more-games-section {
    padding: 16px;
  }

  .game-card-title {
    font-size: 11px;
  }
} 
`, "",{"version":3,"sources":["webpack://./src/pages/Download/Download.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,qFAAqF;EACrF,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA,UAAU;AACV;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA,WAAW;AACX;EACE,iCAAiC;EACjC,sCAAsC;EACtC,aAAa;EACb,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,uBAAuB;EACvB,gCAAgC;EAChC,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,mFAAmF;EACnF,oCAAoC;EACpC,+BAA+B;EAC/B,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,8CAA8C;EAC9C,uBAAuB;EACvB,2BAA2B;EAC3B,qFAAqF;AACvF;;AAEA,UAAU;AACV;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,4BAA4B;EAC9B;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".download-layout {\n  min-height: 100vh;\n  background: var(--color-bg);\n}\n\n.download-content {\n  padding: 24px 0;\n  min-height: calc(100vh - 200px);\n}\n\n.content-container.download-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 24px;\n  width: 100%;\n}\n\n/* 下载信息区域 */\n.download-info-section {\n  margin-bottom: 40px;\n}\n\n.download-info-card {\n  background: var(--color-bg-white);\n  border-radius: 16px;\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  overflow: hidden;\n}\n\n/* 返回按钮 */\n.back-button {\n  padding: 24px 32px 16px 32px;\n  border-bottom: 1px solid #f0f0f0;\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.home-button {\n  color: var(--color-primary);\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.home-button:hover {\n  color: var(--color-primary-hover);\n  background-color: var(--color-primary-light);\n}\n\n/* 应用信息行 */\n.app-info-row {\n  display: grid;\n  grid-template-columns: 1fr 3fr;\n  gap: 24px;\n  padding: 16px 32px 24px 32px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.app-logo-section {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.app-logo-img {\n  width: 160px;\n  height: 160px;\n  object-fit: cover;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n\n.app-details {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.app-name {\n  margin: 0 !important;\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--color-text);\n  line-height: 1.2;\n}\n\n.app-developer {\n  font-size: 14px;\n  color: var(--color-text-secondary);\n}\n\n.app-rating {\n  font-size: 16px;\n  color: var(--color-primary);\n}\n\n/* 下载区域 */\n.download-section {\n  padding: 24px 32px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.download-title {\n  margin: 0 0 24px 0 !important;\n  color: var(--color-text);\n  font-weight: 700;\n  font-size: 18px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding-bottom: 12px;\n  border-bottom: 2px solid var(--color-primary);\n}\n\n.download-buttons {\n  margin-bottom: 16px;\n}\n\n.download-btn {\n  height: 56px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 12px;\n  border: none;\n  transition: all 0.3s ease;\n}\n\n.download-btn.android {\n  background: linear-gradient(135deg, #00b894 0%, #00a085 100%);\n  color: white;\n}\n\n.download-btn.android:hover {\n  background: linear-gradient(135deg, #00a085 0%, #008f76 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 184, 148, 0.3);\n}\n\n.download-btn.ios {\n  background: linear-gradient(135deg, #6c5ce7 0%, #5f4dd0 100%);\n  color: white;\n}\n\n.download-btn.ios:hover {\n  background: linear-gradient(135deg, #5f4dd0 0%, #5240b9 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(108, 92, 231, 0.3);\n}\n\n.download-btn.disabled {\n  background: #f0f0f0 !important;\n  color: #999 !important;\n  cursor: not-allowed;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n.download-hint {\n  display: block;\n  margin-top: 8px;\n  font-size: 12px;\n}\n\n/* 应用描述区域 */\n.app-description {\n  padding: 24px 32px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.app-description .ant-typography {\n  margin: 0 0 16px 0 !important;\n  color: var(--color-text);\n  font-weight: 700;\n  font-size: 18px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding-bottom: 12px;\n  border-bottom: 2px solid var(--color-primary);\n}\n\n.description-content {\n  line-height: 1.6;\n  color: var(--color-text-secondary);\n  white-space: pre-wrap;\n}\n\n/* 安全提示区域 */\n.security-notice {\n  padding: 24px 32px;\n  background: var(--color-bg);\n  border-radius: 0;\n  border-left: none;\n}\n\n.security-text {\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--color-text-secondary);\n}\n\n/* 更多游戏区域 */\n.more-games-section {\n  background: var(--color-bg-white);\n  border-radius: var(--border-radius-lg);\n  padding: 32px;\n  box-shadow: var(--shadow-sm);\n  margin-bottom: 32px;\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.section-title {\n  margin: 0 !important;\n  color: var(--color-text);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.section-icon {\n  color: var(--color-primary);\n  font-size: 16px;\n  margin-right: 8px;\n}\n\n.games-grid {\n  margin-bottom: 24px;\n}\n\n.game-card {\n  background: var(--color-bg-white);\n  border-radius: var(--border-radius);\n  border: 1px solid #f0f0f0;\n  overflow: hidden;\n  cursor: pointer;\n  transition: var(--transition);\n  height: 100%;\n}\n\n.game-card-hover:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n  border-color: rgba(108, 92, 231, 0.2);\n}\n\n.game-card-image {\n  padding: 16px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  aspect-ratio: 1;\n}\n\n.game-card-img {\n  width: 100%;\n  aspect-ratio: 1;\n  object-fit: cover;\n  border-radius: 12px;\n  box-shadow: var(--shadow-sm);\n}\n\n.game-card-info {\n  padding: 0 12px 12px 12px;\n}\n\n.game-card-title {\n  margin: 0 0 8px 0 !important;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--color-text);\n  line-height: 1.3;\n}\n\n.game-card-rating {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.game-card-rating .ant-rate {\n  font-size: 10px !important;\n  color: #faad14 !important;\n}\n\n.rating-text {\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  font-weight: 500;\n}\n\n.random-play-section {\n  text-align: center;\n  padding-top: 24px;\n}\n\n.btn-random-play {\n  background: var(--color-primary) !important;\n  border: none !important;\n  border-radius: 9999px !important;\n  height: 48px !important;\n  padding: 0 32px !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  color: white !important;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 8px;\n}\n\n.btn-random-play:hover {\n  background: rgba(108, 92, 231, 0.9) !important;\n  color: white !important;\n  transform: translateY(-1px);\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .download-content {\n    padding: 16px 0;\n  }\n  \n  .content-container.download-container {\n    padding: 0 16px;\n  }\n  \n  .app-info-row {\n    grid-template-columns: 1fr;\n    gap: 16px;\n    padding: 16px 20px 20px 20px;\n  }\n  \n  .app-logo-img {\n    width: 120px;\n    height: 120px;\n  }\n  \n  .app-name {\n    font-size: 24px !important;\n  }\n  \n  .download-section {\n    padding: 20px;\n  }\n  \n  .download-title {\n    font-size: 16px !important;\n  }\n  \n  .download-btn {\n    height: 48px;\n    font-size: 14px;\n  }\n  \n  .app-description {\n    padding: 20px;\n  }\n  \n  .security-notice {\n    padding: 20px;\n  }\n\n  .more-games-section {\n    padding: 20px;\n  }\n\n  .section-title {\n    font-size: 16px;\n  }\n\n  .game-card-title {\n    font-size: 12px;\n  }\n\n  .btn-random-play {\n    height: 44px !important;\n    font-size: 14px !important;\n    padding: 0 24px !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .content-container.download-container {\n    padding: 0 12px;\n  }\n  \n  .back-button {\n    padding: 20px 20px 12px 20px;\n  }\n  \n  .app-info-row {\n    padding: 12px 16px 16px 16px;\n  }\n  \n  .app-logo-img {\n    width: 100px;\n    height: 100px;\n  }\n  \n  .app-name {\n    font-size: 20px !important;\n  }\n  \n  .download-section {\n    padding: 16px;\n  }\n  \n  .download-title {\n    font-size: 14px !important;\n  }\n  \n  .download-btn {\n    height: 44px;\n    font-size: 13px;\n  }\n  \n  .app-description {\n    padding: 16px;\n  }\n  \n  .security-notice {\n    padding: 16px;\n  }\n\n  .more-games-section {\n    padding: 16px;\n  }\n\n  .game-card-title {\n    font-size: 11px;\n  }\n} \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
